import React, { useState, useEffect, useRef } from "react";

const SearchBar = ({ data, onSearch, searchTerm, setSearchTerm }) => {
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const debounceTimeout = useRef(null);

  useEffect(() => {
    const handleSearch = () => {
      const lowerSearchTerm = searchTerm.toLowerCase();

      if (lowerSearchTerm.length < 2) {
        setError("Please enter a long word!");
        setLoading(false); // Reset loading state
        return;
      } else {
        setError(""); // Clear any previous error message
      }

      setLoading(true);

      const results = data.filter((item) => {
        return (
          item.id.toLowerCase().includes(lowerSearchTerm) ||
          item.itemName.toLowerCase().includes(lowerSearchTerm) ||
          item.itemNumber.toLowerCase().includes(lowerSearchTerm)
        );
      });

      setTimeout(() => {
        onSearch(results);
        setLoading(false);
        // Clear the search term after the search is complete
        setSearchTerm("");
      }, 1500);

      // Clear any previous debounce timeout
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
    };

    // Set a new debounce timeout only if the search term is not empty
    if (searchTerm.trim().length > 0) {
      debounceTimeout.current = setTimeout(handleSearch, 3000);
    }

    return () => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
    };
  }, [searchTerm, data, onSearch, setSearchTerm]);

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
    setError(""); // Clear any previous error message
  };

  return (
    <div>
      <div>
        <div style={{ position: "relative" }}>
          <input
            type="input"
            placeholder="Search Products ..."
            value={searchTerm}
            onChange={handleInputChange}
            style={{
              height: "40px",
              width: "80%",
              paddingLeft: "10px",
              borderColor: "none",
              border: "None",
              boxShadow: "0 0 1px rgb(119, 118, 118)",
            }}
          />
          {loading && (
            <div
              style={{
                position: "absolute",
                top: "50%",
                right: "10px",
                transform: "translateY(-50%)",
              }}
            >
              <img
                src="https://beirabrush-2024.sgp1.digitaloceanspaces.com/cdn.beirabrush.com-uploads/search-loading.gif"
                alt="Loading..."
                className="search-loading"
              />
            </div>
          )}
        </div>
        {error && <p style={{ color: "red" }}>{error}</p>}
      </div>
      <br />
    </div>
  );
};

export default SearchBar;
